<ng-container *ngIf="page_data_loaded">
    <div #pdfDownloadSection>
        <div id="show-pdf-section" #showPDFSection style="margin-bottom: 60px">
            <img src="assets/login.png" style="width: 400px" />
        </div>

        <div id="page-body" style="margin-bottom: 40px;">
            <!-- Heading Section Starts Here -->
            <div class="each-summary-section">
                <div class="summary-section-v2" style="padding-top: 16px; border-radius: 8px 8px 0 0;">
                    <div class="section-heading-section">
                        <span class="section-heading">Summary of Book</span>
                        <ng-container *ngIf="page_type != 'Performance'">
                            <div class="section-heading-tooltip-block">
                                <img src="assets/info-black.png" />
                                <div class="section-heading-tooltip-section">
                                    <div class="module-page-information-section" *ngFor="let section of summary_description_sections">
                                        <div class="each-module-page-information-section">
                                        <p class="each-module-page-information-heading">{{section.name}}</p>
                                        </div>
                                        <ng-container *ngIf="section.sub_sections">
                                            <div class="each-module-page-information-sub-section" *ngFor="let sub_section of section.sub_sections; let index = index">
                                                <p class="each-module-page-information-sub-heading">{{index + 1}}. {{sub_section.name}}:</p>
                                                <p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <div class="recommendations-section-v2" style="padding-top: 16px; border-radius: 8px 8px 0 0;">
                    <div class="section-heading-section">
                        <div>
                            <span class="section-heading" *ngIf="page_type == 'Adjust'">Recommendations</span>
                            <span class="section-heading" *ngIf="page_type == 'Confirm'">Review Recommendations</span>
                            <span class="section-heading" *ngIf="page_type == 'Performance'">Performance</span>
                            <span class="section-heading" *ngIf="page_type == 'Individual'">Recommendations</span>
                            <ng-container *ngIf="page_type != 'Performance'">
                                <div class="section-heading-tooltip-block">
                                    <img src="assets/info-black.png" />
                                    <div class="section-heading-tooltip-section">
                                        <div class="module-page-information-section" *ngFor="let section of description_sections">
                                            <div class="each-module-page-information-section">
                                            <p class="each-module-page-information-heading">{{section.name}}</p>
                                            </div>
                                            <ng-container *ngIf="section.sub_sections">
                                                <div class="each-module-page-information-sub-section" *ngFor="let sub_section of section.sub_sections; let index = index">
                                                    <p class="each-module-page-information-sub-heading">{{index + 1}}. {{sub_section.name}}:</p>
                                                    <p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <div id="hide-pdf-section" #hidePDFSection>
                            <span class="download-pdf-button" *ngIf="!show_pdf_loader" (click)="generatePdfFromImage(pdfDownloadSection)" >Download as PDF</span>
                            <span class="download-pdf-button" *ngIf="show_pdf_loader">Downloading as PDF ...</span>

                            <ng-container *ngIf="page_type == 'Confirm' && !user_details.is_book_optimized">
                                <button class="page-action" style="margin-left: 24px;" (click)="openRevertBackModal()">Revert Back</button>
                                <button class="page-action" style="margin-left: 24px;" (click)="openConfirmModal()">Confirm</button>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Heading Section Ends Here -->

            <!-- Clients & AUM Section Starts Here -->
            <div class="each-summary-section">
                <div class="summary-section-v2">
                    <div class="summary-section-seperator-v2">
                        <div class="summary-graph-section" [ngClass]="{'summary-graph-section-confirm': page_type == 'Confirm'}">
                            <div class="summary-graph-representation">
                                <div id="summary-graph"></div>
                            </div>
                            <div class="summary-graph-details-section">
                                <p class="summary-graph-details-label">Total Clients</p>
                                <p class="summary-graph-details-value" *ngIf="page_type == 'Confirm'">{{commonService.abbreviateNumber(page_data['total_clients'])}}</p>
                                <p class="summary-graph-details-value" *ngIf="page_type == 'Performance'">{{commonService.abbreviateNumber(page_data['total_clients'])}}</p>
                                <p class="summary-graph-details-value pointer" (click)="showRecommendations('Summary', '')" *ngIf="page_type == 'Adjust'">{{commonService.abbreviateNumber(page_data['total_clients'])}}</p>
                                <p class="summary-graph-details-value pointer" (click)="showRecommendations('Summary', '')" *ngIf="page_type == 'Individual'">{{commonService.abbreviateNumber(page_data['total_clients'])}}</p>
                            </div>
                            <div style="width: 100%; text-align: center;">
                                <div class="each-client-recommendation-legend-section" *ngFor="let legend of page_data['total_clients_graph']['labels']; let index = index">
                                    <div class="each-client-recommendation-legend" [style.background]="page_data['total_clients_graph']['colors'][index]"></div>
                                    <p class="each-client-recommendation-legend-label">{{legend}} - {{commonService.abbreviateNumber(page_data['total_clients_graph']['data'][index])}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="summary-details-section" [ngClass]="{'summary-details-section-confirm': page_type == 'Confirm'}">
                            <div>
                                <p class="summary-details-label">Active Clients AUM</p>
                                <p class="summary-details-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(page_data['total_aum'])}}</p>
                            </div>
                            <!-- <img src="assets/summary-aum.png" /> -->
                        </div>
                    </div>
                </div>

                <div class="recommendations-section-v2">
                    <div class="recommendtaions-traits-section">
                        <div class="each-recommendtaions-traits-section" style="border-radius: 8px 8px 0 0;">
                            <div class="recommendation-heading-section">
                                <!-- <span>Increase Focus</span> -->
                                <span>Focused Clients</span>
                            </div>
                            <div class="recommendation-content-section" style=" height: calc(100% - 64px)">
                                <div class="recommendation-inner-section">
                                    <div class="recommendation-inner-heading-section">
                                        <span>Clients</span>
                                    </div>

                                    <div class="each-client-recommendation-section" *ngFor="let increase_focus of page_data['increase_focus']">
                                        <!-- <p class="each-client-recommendation-heading pointer" (click)="showRecommendations('Summary', 'Increase Focus')" *ngIf="page_type == 'Adjust'">{{commonService.abbreviateNumber(increase_focus.value)}}</p> -->

                                        <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
                                            <span class="each-client-recommendation-heading pointer" (click)="showRecommendations('Summary', 'Increase Focus')" *ngIf="page_type == 'Adjust'">{{commonService.abbreviateNumber(increase_focus.value)}}</span>
                                            <span class="each-client-recommendation-heading pointer" (click)="showRecommendations('Summary', 'Increase Focus')" *ngIf="page_type == 'Individual'">{{commonService.abbreviateNumber(increase_focus.value)}}</span>
                                            <button class="trait-button" (click)="showRecommendations('Summary', 'Increase Focus')" *ngIf="page_type == 'Adjust'">View</button>
                                            <button class="trait-button" (click)="showRecommendations('Summary', 'Increase Focus')" *ngIf="page_type == 'Individual'">View</button>
                                        </div>


                                        <p class="each-client-recommendation-heading" *ngIf="page_type == 'Confirm'">{{commonService.abbreviateNumber(increase_focus.value)}}</p>
                                        <p class="each-client-recommendation-heading" *ngIf="page_type == 'Performance'">{{commonService.abbreviateNumber(increase_focus.value)}}</p>
                                        <div class="each-client-recommendation-outer-bar">
                                            <div class="each-client-recommendation-inner-bar" *ngFor="let inner_bar of increase_focus.child" [style.background]="inner_bar.color" [style.width]="inner_bar.width + '%'"></div>
                                        </div>
                                    </div>

                                    <div class="recommendation-inner-heading-section">
                                        <span>AUM</span>
                                    </div>
                                    <div class="each-client-recommendation-section" *ngFor="let increase_focus of page_data['increase_focus']">
                                        <span class="each-client-recommendation-heading" [style.color]="increase_focus.color">{{increase_focus.aum}}</span>
                                    </div>

                                    <!-- <ng-container *ngIf="page_type == 'Confirm'"> -->
                                    <ng-container>
                                        <ng-container *ngFor="let increase_focus of page_data['increase_focus']">
                                            <div class="each-client-recommendation-legend-section" *ngFor="let inner_bar of increase_focus.child">
                                                <div class="each-client-recommendation-legend" [style.background]="inner_bar.color"></div>
                                                <p class="each-client-recommendation-legend-label">{{inner_bar.name}} - {{commonService.abbreviateNumber(inner_bar.value)}} ({{inner_bar.aum}})</p>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                    <div class="view-explanantion-section" *ngIf="show_recommendations_explanation">
                                        <ng-container *ngFor="let increase_focus of page_data['increase_focus']; let index = index;">
                                            <div class="each-view-explanantion-section" *ngIf="index == 0">
                                                <p class="view-explanantion-heading">{{increase_focus.name}}</p>
                                                <p class="view-explanantion-content" [innerHTML]="increase_focus.explanation"></p>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="each-recommendtaions-traits-section delegate-agi-bg" style="border-radius: 8px 8px 0 0;">
                            <div class="recommendation-heading-section">
                                <!-- <span>Delegate MAGI</span> -->
                                <span>MAGI</span>
                            </div>
                            <div class="recommendation-content-section" style=" height: calc(100% - 64px)">
                                <div class="recommendation-inner-section">
                                    <div class="recommendation-inner-heading-section">
                                        <span>Clients</span>
                                    </div>

                                    <div class="each-client-recommendation-section" *ngFor="let delegate_agi of page_data['delegate_agi']">
                                        <!-- <p class="each-client-recommendation-heading pointer" (click)="showRecommendations('Summary', 'Delegate MAGI')" *ngIf="page_type == 'Adjust'">{{commonService.abbreviateNumber(delegate_agi.value)}}</p> -->

                                        <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
                                            <span class="each-client-recommendation-heading pointer" (click)="showRecommendations('Summary', 'Delegate MAGI')" *ngIf="page_type == 'Adjust'">{{commonService.abbreviateNumber(delegate_agi.value)}}</span>
                                            <span class="each-client-recommendation-heading pointer" (click)="showRecommendations('Summary', 'Delegate MAGI')" *ngIf="page_type == 'Individual'">{{commonService.abbreviateNumber(delegate_agi.value)}}</span>
                                            <button class="trait-button" (click)="showRecommendations('Summary', 'Delegate MAGI')" *ngIf="page_type == 'Adjust'">View / Assign</button>
                                            <button class="trait-button" (click)="showRecommendations('Summary', 'Delegate MAGI')" *ngIf="page_type == 'Individual'">View / Assign</button>
                                        </div>

                                        <p class="each-client-recommendation-heading" *ngIf="page_type == 'Confirm'">{{commonService.abbreviateNumber(delegate_agi.value)}}</p>
                                        <p class="each-client-recommendation-heading" *ngIf="page_type == 'Performance'">{{commonService.abbreviateNumber(delegate_agi.value)}}</p>
                                        <div class="each-client-recommendation-outer-bar">
                                            <div class="each-client-recommendation-inner-bar" *ngFor="let inner_bar of delegate_agi.child" [style.background]="inner_bar.color" [style.width]="inner_bar.width + '%'"></div>
                                        </div>
                                    </div>

                                    <div class="recommendation-inner-heading-section">
                                        <span>AUM</span>
                                    </div>
                                    <div class="each-client-recommendation-section" *ngFor="let delegate_agi of page_data['delegate_agi']">
                                        <span class="each-client-recommendation-heading" [style.color]="delegate_agi.color">{{delegate_agi.aum}}</span>
                                    </div>

                                    <!-- <ng-container *ngIf="page_type == 'Confirm'"> -->
                                    <ng-container>
                                        <ng-container *ngFor="let delegate_agi of page_data['delegate_agi']">
                                            <div class="each-client-recommendation-legend-section" *ngFor="let inner_bar of delegate_agi.child">
                                                <div class="each-client-recommendation-legend" [style.background]="inner_bar.color"></div>
                                                <p class="each-client-recommendation-legend-label">{{inner_bar.name}} - {{commonService.abbreviateNumber(inner_bar.value)}} ({{inner_bar.aum}})</p>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                    <div class="view-explanantion-section" *ngIf="show_recommendations_explanation">
                                        <ng-container *ngFor="let delegate_agi of page_data['delegate_agi']; let index = index;">
                                            <div class="each-view-explanantion-section" *ngIf="index == 0">
                                                <p class="view-explanantion-heading">{{delegate_agi.name}}</p>
                                                <p class="view-explanantion-content" [innerHTML]="delegate_agi.explanation"></p>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="each-recommendtaions-traits-section delegate-afa-bg" style="border-radius: 8px 8px 0 0;">
                            <div class="recommendation-heading-section">
                                <!-- <span>Delegate AFA</span> -->
                                <!-- <span>AFA</span> -->
                                <span>Junior Advisor</span>
                            </div>
                            <div class="recommendation-content-section" style=" height: calc(100% - 64px)">
                                <div class="recommendation-inner-section">
                                    <div class="recommendation-inner-heading-section">
                                        <span>Clients</span>
                                    </div>

                                    <div class="each-client-recommendation-section" *ngFor="let delegate_afa of page_data['delegate_afa']">
                                        <!-- <p class="each-client-recommendation-heading pointer" (click)="showRecommendations('Summary', 'Delegate AFA')" *ngIf="page_type == 'Adjust'">{{commonService.abbreviateNumber(delegate_afa.value)}}</p> -->

                                        <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
                                            <span class="each-client-recommendation-heading pointer" (click)="showRecommendations('Summary', 'Delegate AFA')" *ngIf="page_type == 'Adjust'">{{commonService.abbreviateNumber(delegate_afa.value)}}</span>
                                            <span class="each-client-recommendation-heading pointer" (click)="showRecommendations('Summary', 'Delegate AFA')" *ngIf="page_type == 'Individual'">{{commonService.abbreviateNumber(delegate_afa.value)}}</span>
                                            <button class="trait-button" (click)="showRecommendations('Summary', 'Delegate AFA')" *ngIf="page_type == 'Adjust'">View / Assign</button>
                                            <button class="trait-button" (click)="showRecommendations('Summary', 'Delegate AFA')" *ngIf="page_type == 'Individual'">View / Assign</button>
                                        </div>

                                        <p class="each-client-recommendation-heading" *ngIf="page_type == 'Confirm'">{{commonService.abbreviateNumber(delegate_afa.value)}}</p>
                                        <p class="each-client-recommendation-heading" *ngIf="page_type == 'Performance'">{{commonService.abbreviateNumber(delegate_afa.value)}}</p>
                                        <div class="each-client-recommendation-outer-bar">
                                            <div class="each-client-recommendation-inner-bar" *ngFor="let inner_bar of delegate_afa.child" [style.background]="inner_bar.color" [style.width]="inner_bar.width + '%'"></div>
                                        </div>
                                    </div>

                                    <div class="recommendation-inner-heading-section">
                                        <span>AUM</span>
                                    </div>
                                    <div class="each-client-recommendation-section" *ngFor="let delegate_afa of page_data['delegate_afa']">
                                        <span class="each-client-recommendation-heading" [style.color]="delegate_afa.color">{{delegate_afa.aum}}</span>
                                    </div>

                                    <!-- <ng-container *ngIf="page_type == 'Confirm'"> -->
                                    <ng-container>
                                        <ng-container *ngFor="let delegate_afa of page_data['delegate_afa']">
                                            <div class="each-client-recommendation-legend-section" *ngFor="let inner_bar of delegate_afa.child">
                                                <div class="each-client-recommendation-legend" [style.background]="inner_bar.color"></div>
                                                <p class="each-client-recommendation-legend-label">{{inner_bar.name}} - {{commonService.abbreviateNumber(inner_bar.value)}} ({{inner_bar.aum}})</p>
                                            </div>
                                        </ng-container>
                                    </ng-container>


                                    <div class="view-explanantion-section" *ngIf="show_recommendations_explanation">
                                        <ng-container *ngFor="let delegate_afa of page_data['delegate_afa']; let index = index;">
                                            <div class="each-view-explanantion-section" *ngIf="index == 0">
                                                <p class="view-explanantion-heading">{{delegate_afa.name}}</p>
                                                <p class="view-explanantion-content" [innerHTML]="delegate_afa.explanation"></p>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!-- Clients & AUM Section Ends Here -->

            <!-- Incremental AUM Section Starts Here -->
            <div class="each-summary-section">
                <div class="summary-section-v2">
                    <div class="summary-section-seperator-v2">
                        <p class="prediction-info-text">* Represents Predictions for next 3 years</p>
                        <div class="summary-details-section">
                            <div>
                                <!-- <p class="summary-details-label">Rate of Growth </p> -->
                                <p class="summary-details-label">Historical Rate of Growth</p>
                                <p class="summary-details-value">{{page_data['growth_rate']}}%</p>
                            </div>
                            <!-- <img src="assets/summary-rate-growth.png" /> -->
                        </div>
                        <div class="summary-details-section" *ngIf="page_type != 'Performance'">
                            <div>
                                <p class="summary-details-label">Predicted Rate of Growth *</p>
                                <p class="summary-details-value">{{commonService.abbreviateNumber(page_data['all_growth_rate'][incremental_aum_slider_value])}}%</p>
                            </div>
                            <!-- <img src="assets/summary-predicted-growth.png" /> -->
                        </div>
                        <div class="summary-details-section">
                            <div>
                                <p class="summary-details-label">Predicted Growth *</p>
                                <!-- <p class="summary-details-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(page_data['predicted_growth'])}}</p> -->
                                <p class="summary-details-value" *ngIf="page_type != 'Performance'">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber((page_data['predicted_growth']) * (incremental_aum_slider_value/100))}}</p>
                                <p class="summary-details-value" *ngIf="page_type == 'Performance'">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(page_data['predicted_growth'])}}</p>

                                <div class="summary-calculator-slider-section" *ngIf="page_type != 'Performance'" style="width: 240px;">
                                    <span class="summary-calculator-slider-label">10%</span>
                                    <div class="summary-calculator-slider">
                                        <mat-slider thumbLabel [displayWith]="formatLabel" min="10" max="100" step="10"[(ngModel)]="incremental_aum_slider_value"></mat-slider>
                                    </div>
                                    <span class="summary-calculator-slider-label">100%</span>
                                </div>
                            </div>
                            <!-- <img src="assets/summary-predicted-growth.png" /> -->
                        </div>
                    </div>
                </div>

                <div class="recommendations-section-v2">
                    <div class="recommendtaions-traits-section">
                        <div class="each-recommendtaions-traits-section">
                            <div class="recommendation-content-section">
                                <div class="recommendation-inner-section">
                                    <div class="recommendation-inner-heading-section">
                                        <span>Incremental AUM</span>
                                    </div>
                                    <div id="increase-focus-aum-graph"></div>

                                    <div class="summary-calculator-slider-section" *ngIf="page_type != 'Performance'">
                                        <span class="summary-calculator-slider-label">10%</span>
                                        <div class="summary-calculator-slider">
                                            <mat-slider thumbLabel [displayWith]="formatLabel" min="10" max="100" step="10"[(ngModel)]="increase_foucs_aum_slider_value" (change)="createIncreaseFoucsAUMGraph(page_data['increase_focus_incremental_graph'])"></mat-slider>
                                        </div>
                                        <span class="summary-calculator-slider-label">100%</span>
                                    </div>

                                    <p class="view-explanantion-heading" *ngIf="page_type != 'Performance'">Predicted Growth ({{increase_foucs_aum_slider_value}}%) - {{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber((page_data['increase_focus_forecasted_aum'] * (increase_foucs_aum_slider_value/100)))}}</p>

                                    <div class="view-explanantion-section" *ngIf="show_recommendations_explanation">
                                        <div class="each-view-explanantion-section">
                                            <p class="view-explanantion-heading">Explanation</p>
                                            <!-- <p class="view-explanantion-content" [innerHTML]="page_data.increase_focus_incremental_graph.explanation"></p> -->
                                            <div class="view-explanantion-content">
                                                <span [innerHTML]="page_data.increase_focus_incremental_graph.explanation"></span>
                                                <span><strong>{{page_data['increase_focus_growth_rate_explanation'][increase_foucs_aum_slider_value]}}%</strong></span>
                                                <span [innerHTML]="page_data.increase_focus_incremental_graph.explanation2"></span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="each-recommendtaions-traits-section delegate-agi-bg">
                            <div class="recommendation-content-section">
                                <div class="recommendation-inner-section">
                                    <div class="recommendation-inner-heading-section">
                                        <span>Incremental AUM</span>
                                    </div>
                                    <div id="delegate-agi-aum-graph"></div>



                                    <div class="summary-calculator-slider-section" *ngIf="page_type != 'Performance'">
                                        <span class="summary-calculator-slider-label">10%</span>
                                        <div class="summary-calculator-slider">
                                            <mat-slider thumbLabel [displayWith]="formatLabel" min="10" max="100" step="10"[(ngModel)]="delegate_agi_aum_slider_value" (change)="createDelegateMAGIAUMGraph(page_data['agi_incremental_graph'])"></mat-slider>
                                        </div>
                                        <span class="summary-calculator-slider-label">100%</span>
                                    </div>

                                    <p class="view-explanantion-heading" *ngIf="page_type != 'Performance'">Predicted Growth ({{delegate_agi_aum_slider_value}}%) - {{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber((page_data['agi_forecasted_aum'] * (delegate_agi_aum_slider_value/100)))}}</p>

                                    <div class="view-explanantion-section" *ngIf="show_recommendations_explanation">
                                        <div class="each-view-explanantion-section">
                                            <p class="view-explanantion-heading">Explanation</p>
                                            <!-- <p class="view-explanantion-content" [innerHTML]="page_data.agi_incremental_graph.explanation"></p> -->
                                            <div class="view-explanantion-content">
                                                <span [innerHTML]="page_data.agi_incremental_graph.explanation"></span>
                                                <span><strong>{{page_data['agi_growth_rate_explanation'][delegate_agi_aum_slider_value]}}%</strong></span>
                                                <span [innerHTML]="page_data.agi_incremental_graph.explanation2"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="each-recommendtaions-traits-section delegate-afa-bg">
                            <div class="recommendation-content-section">
                                <div class="recommendation-inner-section">
                                    <div class="recommendation-inner-heading-section">
                                        <span>Incremental AUM</span>
                                    </div>
                                    <div id="delegate-afa-aum-graph"></div>

                                    <div class="summary-calculator-slider-section" *ngIf="page_type != 'Performance'">
                                        <span class="summary-calculator-slider-label">10%</span>
                                        <div class="summary-calculator-slider">
                                            <mat-slider thumbLabel [displayWith]="formatLabel" min="10" max="100" step="10"[(ngModel)]="delegate_afa_aum_slider_value" (change)="createDelegateAFAAUMGraph(page_data['afa_incremental_graph'])"></mat-slider>
                                        </div>
                                        <span class="summary-calculator-slider-label">100%</span>
                                    </div>

                                    <p class="view-explanantion-heading" *ngIf="page_type != 'Performance'">Predicted Growth ({{delegate_afa_aum_slider_value}}%) - {{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber((page_data['afa_forecasted_aum'] * (delegate_afa_aum_slider_value/100)))}}</p>

                                    <div class="view-explanantion-section" *ngIf="show_recommendations_explanation">
                                        <div class="each-view-explanantion-section">
                                            <p class="view-explanantion-heading">Explanation</p>
                                            <!-- <p class="view-explanantion-content" [innerHTML]="page_data.afa_incremental_graph.explanation"></p> -->
                                            <div class="view-explanantion-content">
                                                <span [innerHTML]="page_data.afa_incremental_graph.explanation"></span>
                                                <span><strong>{{page_data['afa_growth_rate_explanation'][delegate_afa_aum_slider_value]}}%</strong></span>
                                                <span [innerHTML]="page_data.afa_incremental_graph.explanation2"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Incremental AUM Section Starts Here -->

            <!-- Attrition Risk Section Starts Here -->
            <div class="each-summary-section">
                <div class="summary-section-v2">
                    <div class="summary-section-seperator-v2">
                        <p class="prediction-info-text">* Represents Predictions for next 3 years</p>
                        <div class="summary-details-section">
                            <div>
                                <!-- <p class="summary-details-label">Rate of Attrition </p> -->
                                <p class="summary-details-label">Historical Rate of Attrition </p>
                                <p class="summary-details-value">{{page_data['attrition_rate']}}%</p>
                            </div>
                            <!-- <img src="assets/summary-rate-growth.png" /> -->
                        </div>
                        <div class="summary-details-section" *ngIf="page_type != 'Performance'">
                            <div>
                                <p class="summary-details-label">Predicted Rate of Attrition *</p>
                                <p class="summary-details-value">{{page_data['predicted_attrition_rate']}}%</p>
                            </div>
                            <!-- <img src="assets/summary-rate-growth.png" /> -->
                        </div>
                        <div class="summary-details-section">
                            <div>
                                <!-- <p class="summary-details-label">Attrition AUM</p> -->
                                <p class="summary-details-label">Predicted Attrition AUM *</p>
                                <p class="summary-details-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(page_data['attrition_aum'])}}</p>
                            </div>
                            <!-- <img src="assets/summary-aum.png" /> -->
                        </div>
                    </div>
                </div>

                <div class="recommendations-section-v2">
                    <div class="recommendtaions-traits-section">
                        <div class="each-recommendtaions-traits-section">
                            <div class="recommendation-content-section">
                                <div class="recommendation-inner-section">
                                    <div class="recommendation-inner-heading-section">
                                        <!-- <span>Retention Risk</span> -->
                                        <span>Attrition Risk</span>
                                    </div>
                                    <div id="increase-focus-risk-graph"></div>

                                    <p class="view-explanantion-heading" *ngIf="page_type != 'Performance'">Predicted Loss - {{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(page_data['increase_focus_attrition_aum'])}}</p>

                                    <div class="view-explanantion-section" *ngIf="show_recommendations_explanation">
                                        <div class="each-view-explanantion-section">
                                            <p class="view-explanantion-heading">Explanation</p>
                                            <p class="view-explanantion-content" [innerHTML]="page_data.increase_focus_retention_graph.explanation"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="each-recommendtaions-traits-section delegate-agi-bg">
                            <div class="recommendation-content-section">
                                <div class="recommendation-inner-section">
                                    <div class="recommendation-inner-heading-section">
                                        <!-- <span>Retention Risk</span> -->
                                        <span>Attrition Risk</span>
                                    </div>
                                    <div id="delegate-agi-risk-graph"></div>

                                    <p class="view-explanantion-heading" *ngIf="page_type != 'Performance'">Predicted Loss - {{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(page_data['agi_attrition_aum'])}}</p>

                                    <div class="view-explanantion-section" *ngIf="show_recommendations_explanation">
                                        <div class="each-view-explanantion-section">
                                            <p class="view-explanantion-heading">Explanation</p>
                                            <p class="view-explanantion-content" [innerHTML]="page_data.agi_retention_graph.explanation"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="each-recommendtaions-traits-section delegate-afa-bg">
                            <div class="recommendation-content-section">
                                <div class="recommendation-inner-section">
                                    <div class="recommendation-inner-heading-section">
                                        <!-- <span>Retention Risk</span> -->
                                        <span>Attrition Risk</span>
                                    </div>
                                    <div id="delegate-afa-risk-graph"></div>

                                    <p class="view-explanantion-heading" *ngIf="page_type != 'Performance'">Predicted Loss - {{APP_CONSTANTS.CURRENCY_SYMBOL}}{{commonService.abbreviateNumber(page_data['afa_attrition_aum'])}}</p>

                                    <div class="view-explanantion-section" *ngIf="show_recommendations_explanation">
                                        <div class="each-view-explanantion-section">
                                            <p class="view-explanantion-heading">Explanation</p>
                                            <p class="view-explanantion-content" [innerHTML]="page_data.afa_retention_graph.explanation"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Attrition Risk Section Ends Here -->

            <!-- Client Engagement Section Starts Here -->
            <div class="each-summary-section">
                <div class="summary-section-v2">
                    <div class="summary-section-seperator-v2">
                        <p class="prediction-info-text">* Represents Predictions for next 3 years</p>
                        <div class="summary-details-section">
                            <div>
                                <p class="summary-details-label">Client Engagement Score *</p>
                                <p class="summary-details-value">{{commonService.abbreviateNumber(page_data['client_engagement_score'])}}</p>
                            </div>
                            <!-- <img src="assets/summary-predicted-growth.png" /> -->
                        </div>
                        <div class="summary-details-section">
                            <div>
                                <p class="summary-details-label">Number of Activities *</p>
                                <p class="summary-details-value">{{commonService.abbreviateNumber(page_data['activities_count'])}}</p>
                            </div>
                            <!-- <img src="assets/summary-predicted-growth.png" /> -->
                        </div>
                    </div>
                </div>

                <div class="recommendations-section-v2">
                    <div class="recommendtaions-traits-section">
                        <div class="each-recommendtaions-traits-section">
                            <div class="recommendation-content-section">
                                <div class="recommendation-inner-section">
                                    <div class="recommendation-inner-heading-section">
                                        <span>Client Engagement</span>
                                    </div>
                                    <div id="increase-focus-engagement-graph"></div>
                                    <div class="view-explanantion-section" *ngIf="show_recommendations_explanation">
                                        <div class="each-view-explanantion-section">
                                            <p class="view-explanantion-heading">Explanation</p>
                                            <p class="view-explanantion-content" [innerHTML]="page_data.increase_focus_client_engagement_graph.explanation"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="each-recommendtaions-traits-section delegate-agi-bg">
                            <div class="recommendation-content-section">
                                <div class="recommendation-inner-section">
                                    <div class="recommendation-inner-heading-section">
                                        <span>Client Engagement</span>
                                    </div>
                                    <div id="delegate-agi-engagement-graph"></div>
                                    <div class="view-explanantion-section" *ngIf="show_recommendations_explanation">
                                        <div class="each-view-explanantion-section">
                                            <p class="view-explanantion-heading">Explanation</p>
                                            <p class="view-explanantion-content" [innerHTML]="page_data.agi_client_engagement_graph.explanation"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="each-recommendtaions-traits-section delegate-afa-bg">
                            <div class="recommendation-content-section">
                                <div class="recommendation-inner-section">
                                    <div class="recommendation-inner-heading-section">
                                        <span>Client Engagement</span>
                                    </div>
                                    <div id="delegate-afa-engagement-graph"></div>
                                    <div class="view-explanantion-section" *ngIf="show_recommendations_explanation">
                                        <div class="each-view-explanantion-section">
                                            <p class="view-explanantion-heading">Explanation</p>
                                            <p class="view-explanantion-content" [innerHTML]="page_data.afa_client_engagement_graph.explanation"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Client Engagement Section Ends Here -->

        </div>

        <div id="scrollble-body">
            <ng-container *ngIf="analysis_value != ''">
                <ng-container *ngIf="analysis_data_loaded">

                    <div class="analysis-section">
                        <div class="analysis-heading-section">
                            <ng-container *ngIf="analysis_value == 'Summary'">
                                <ng-container *ngIf="analysis_value_filter == ''">
                                    <span>Total Clients</span>
                                    <span class="analysis-heading-value">
                                        <img src="assets/analysis-clients.png" class="analysis-heading-icon" />
                                        {{commonService.abbreviateNumber(page_data['total_clients'])}} Total Clients
                                    </span>
                                </ng-container>

                                <ng-container *ngIf="analysis_value_filter == 'Increase Focus'">
                                    <span>Focused Clients</span>
                                    <span class="analysis-heading-value">
                                        <img src="assets/analysis-clients.png" class="analysis-heading-icon" />
                                        {{commonService.abbreviateNumber(page_data['increase_focus'][0].value)}} Focused Clients
                                    </span>
                                </ng-container>

                                <ng-container *ngIf="analysis_value_filter == 'Delegate MAGI'">
                                    <span>MAGI Clients</span>
                                    <span class="analysis-heading-value">
                                        <img src="assets/analysis-clients.png" class="analysis-heading-icon" />
                                        {{commonService.abbreviateNumber(page_data['delegate_agi'][0].value)}} MAGI Clients
                                    </span>
                                </ng-container>

                                <ng-container *ngIf="analysis_value_filter == 'Delegate AFA'">
                                    <!-- <span>AFA Clients</span> -->
                                    <span>Junior Advisor Clients</span>
                                    <span class="analysis-heading-value">
                                        <img src="assets/analysis-clients.png" class="analysis-heading-icon" />
                                        <!-- {{commonService.abbreviateNumber(page_data['delegate_afa'][0].value)}} AFA Clients -->
                                        {{commonService.abbreviateNumber(page_data['delegate_afa'][0].value)}} Junior Advisor Clients
                                    </span>
                                </ng-container>
                            </ng-container>

                        </div>

                        <div>
                            <span class="analysis-close-icon" (click)="analysis_value = ''; analysis_value_filter = ''; analysis_data_loaded = false;">&times;</span>
                        </div>
                    </div>

                    <ng-container *ngIf="analysis_value == 'Summary'">
                        <!-- <app-advisor-view-recommendations [recommendation_filter]="analysis_value_filter" (dataChanged)="dataChanged({{APP_CONSTANTS.CURRENCY_SYMBOL}}event)"></app-advisor-view-recommendations> -->
                        <app-advisor-view-optimised-recommentaions [recommendation_filter]="analysis_value_filter" [page_type]="page_type" [advisor_details]="advisor_details" (dataChanged)="dataChanged($event)"></app-advisor-view-optimised-recommentaions>
                    </ng-container>

                </ng-container>

                <ng-container *ngIf="!analysis_data_loaded">
                    <app-loader [loading_text]="'Loading'"></app-loader>
                </ng-container>

            </ng-container>
        </div>
    </div>
    <div *ngIf="page_type != 'Performance'">
        <div id="hide-pdf-section" #hidePDFSection>
            <ng-container *ngIf="page_type == 'Adjust'">
                <div class="page-action-section">
                    <button class="page-action" (click)="navigateToStep(1)">Previous Step</button>
                    <button class="page-action" (click)="navigateToStep(3)">Next Step</button>
                </div>
            </ng-container>
            <ng-container *ngIf="page_type == 'Confirm'">
                <div class="page-action-section">
                    <button class="page-action" (click)="navigateToStep(2)">Previous Step</button>
                    <div *ngIf="!user_details.is_book_optimized">
                        <button class="page-action" style="margin-left: 24px;" (click)="openRevertBackModal()">Revert Back</button>
                        <button class="page-action" style="margin-left: 24px;" (click)="openConfirmModal()">Confirm</button>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!page_data_loaded">
    <app-loader [loading_text]="'Loading'"></app-loader>
</ng-container>

<ng-template #confirmModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>Confirm Adjusted Recommendations</span>
            <span class="page-modal-close-icon" (click)="closeConfirmModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to apply recommendations?</p>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="confirmRecommendations()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeConfirmModal()">No</button>
        </div>
    </div>
</ng-template>

<ng-template #revertBackModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>Revert Back Recommendations</span>
            <span class="page-modal-close-icon" (click)="closeRevertBackModal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to revert back recommendations?</p>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-primary-button" (click)="revertBackRecommendations()">Yes</button>
            <button class="page-modal-secondary-button" (click)="closeRevertBackModal()">No</button>
        </div>
    </div>
</ng-template>
